import { PayloadAction } from '@reduxjs/toolkit'
import { reducerCreatorProducer } from 'store/common'
import { IAiLibState, IVideoFilters } from 'store/types/aiLib'
import { IAIVideoModel, IAIVideoProject } from 'types/aiVideo'
import { getInitialState } from 'store/features/aiLibVideo/initialState'

const reducers = reducerCreatorProducer<IAiLibState>()({
  resetFilters: state => {
    state.filters = getInitialState().filters
  },
  setActiveTab: (state, action: PayloadAction<string>) => {
    state.activeTab = action.payload
  },
  toggleFiltersOpen: state => {
    state.isFiltersOpen = !state.isFiltersOpen
  },
  closeFilters: state => {
    state.isFiltersOpen = false
  },
  setFilter: (state, action: PayloadAction<Partial<IVideoFilters>>) => {
    state.filters = { ...state.filters, ...action.payload }
  },
  setIsLoaded: (state, action: PayloadAction<boolean>) => {
    state.isLoaded = action.payload
  },
  setIsInitialLoading: (state, action: PayloadAction<boolean>) => {
    state.isInitialLoading = action.payload
  },
  setIsLoadingMore: (state, action: PayloadAction<boolean>) => {
    state.isLoadingMore = action.payload
  },
  setHistoryList: (state, action: PayloadAction<IAIVideoProject[]>) => {
    state.historyList = action.payload
  },
  appendHistoryList: (state, action: PayloadAction<IAIVideoProject[]>) => {
    state.historyList.push(...action.payload)
  },
  setHistoryTotalCount: (state, action: PayloadAction<number>) => {
    state.historyTotalCount = action.payload
  },
  setAllModels: (state, action: PayloadAction<IAIVideoModel[]>) => {
    state.allModels = action.payload
  },
  setAllModelsLoading: (state, action: PayloadAction<boolean>) => {
    state.isAllModelsLoading = action.payload
  }
})

export default reducers
